<template>
    <div style="background: #fff; padding: 20px">
        <el-button style="float: right; margin-left: 10px" type="info" @click="outExcel">{{ $t('common.export') }}</el-button>
        <el-button style="float: right" type="primary" @click="printContext" v-if="perData.allow_print == 1">{{ $t('common.print') }}</el-button>
        <el-button style="float: right; margin-right: 10px" type="primary" @click="toImg" v-if="perData.allow_print == 1"
            >转图片下载</el-button
        >
        <el-button style="float: right" type="warning" @click="outData.isshow = true">{{ $t('common.filter') }}</el-button>
        <div class="totaltable" style="margin-top: 30px; clear: both">
            <div id="print" ref="print" style="text-align: center; page-break-after: always; clear: both; padding: 10px">
                <p class="company" v-if="systemSet.company">{{ systemSet.company }}</p>
                <div style="font-size: 16px; font-weight: bold; margin-bottom: 10px">来料统计表</div>
                <table border="1" cellpadding="0" cellspacing="0">
                    <tr align="center">
                        <th>单据类型</th>
                        <th>品类</th>
                        <th>客户类型</th>
                        <th>客户名称</th>
                        <th>日期</th>
                        <th>单号</th>
                        <th>重量</th>
                        <th>数量</th>
                        <th>金额</th>
                    </tr>
                    <tr
                        align="center"
                        v-for="(item, index) in dtlArr"
                        :key="index"
                        :style="item['类型'] == '总计' ? 'color:red;font-weight:bold' : ''"
                    >
                        <td style="background: #fff" :rowspan="item.bill_type_count_s" v-if="item.bill_type_name_s">
                            {{ item['单据类型'] == '这里是一个空值哈哈哈哈' ? '' : item['单据类型'] }}
                        </td>
                        <td style="background: #fff" :rowspan="item.category_count_s" v-if="item.category_name_s">
                            {{ item['品类'] == '这里是一个空值哈哈哈哈' ? '' : item['品类'] }}
                        </td>
                        <td style="background: #fff" :rowspan="item.cust_type_count_s" v-if="item.cust_type_name_s">
                            {{ item['客户类型'] == '这里是一个空值哈哈哈哈' ? '' : item['客户类型'] }}
                        </td>
                        <td
                            style="background: #fff"
                            :rowspan="item.cust_name_count_s"
                            :colspan="item.date_name_s == '' ? 3 : ''"
                            v-if="item.cust_name_name_s"
                        >
                            {{ item['客户名称'] == '这里是一个空值哈哈哈哈' ? '' : item['客户名称'] }}
                        </td>
                        <td style="background: #fff" :rowspan="item.date_count_s" v-if="item.date_name_s">
                            {{ item['日期'] == '这里是一个空值哈哈哈哈' ? '' : item['日期'] }}
                        </td>
                        <td v-if="item['单号']">{{ item['单号'] }}</td>
                        <td>{{ item['重量'] }}</td>
                        <td>{{ item['数量'] }}</td>
                        <td>{{ item['金额'] }}</td>
                    </tr>
                </table>

                <big-name></big-name>
            </div>
        </div>
        <div class="pagination">
            <el-pagination
                background
                layout="total, sizes, prev, pager, next, jumper"
                :current-page="pageIndex"
                :page-size="pageSize"
                :page-sizes="[30, 40, 50]"
                :total="pageTotal"
                @current-change="handlePageChange"
                @size-change="pageSizeChange"
            ></el-pagination>
        </div>
        <!-- 筛选弹出框 -->
        <el-dialog style="padding: 0 20px" :title="$t('common.filter')" :visible.sync="outData.isshow" width="60%">
            <div class="box1">
                <el-button type="success" icon="el-icon-plus" plain circle @click="showInput"></el-button>
                <div
                    style="margin-top: 20px; display: flex; flex-wrap: wrap; align-items: center"
                    v-for="(tag, index) in bonusData.table"
                    :key="index"
                >
                    <el-select filterable @change="selectOne1(index)" v-model="bonusData.table[index]" placeholder="请选择">
                        <el-option
                            v-for="item in allArr.screen_pull[0].field"
                            :key="item.name_no"
                            :label="item.name"
                            :value="item.name_no"
                        ></el-option>
                    </el-select>
                    <span style="display: inline-block; margin: 0 10px">-</span>
                    <el-select filterable v-model="bonusData.condition[index]" placeholder="请选择" @change="selectOne_vague(index)">
                        <el-option
                            v-for="item in allArr.screen_condition"
                            :key="item.name_no"
                            :label="item.name"
                            :value="item.name_no"
                        ></el-option>
                    </el-select>
                    <span style="display: inline-block; margin: 0 10px">-</span>
                    <!-- <el-select
                        filterable
                        v-if="allArr.screen_pull[0].field[arrs[index] ? arrs[index] : 0].select && vague"
                        v-model="bonusData.parameter[index]"
                        placeholder="请选择"
                    >
                        <el-option
                            v-for="(item, index) in allArr.screen_pull[0].field[arrs[index] ? arrs[index] : 0].select"
                            :key="index"
                            :label="item.kind_name"
                            :value="item.kind_no"
                        ></el-option>
                    </el-select>
                    <el-input style="width: 20%" v-else v-model="bonusData.parameter[index]" placeholder="请输入"></el-input> -->
                    <template v-if="bonusData.table[index] != '日期'">
                        <el-select
                            filterable
                            v-if="allArr.screen_pull[0].field[arrs[index] ? arrs[index] : 0].select && vague"
                            v-model="bonusData.parameter[index]"
                            placeholder="请选择"
                        >
                            <el-option
                                v-for="(item, index) in allArr.screen_pull[0].field[arrs[index] ? arrs[index] : 0].select"
                                :key="index"
                                :label="item.kind_name"
                                :value="item.kind_no"
                            ></el-option>
                        </el-select>
                        <el-input style="width: 20%" v-else v-model="bonusData.parameter[index]" placeholder="请输入"></el-input>
                    </template>
                    <template v-else>
                        <el-date-picker v-model="bonusData.parameter[index]" type="date" placeholder="选择日期" value-format="yyyy-MM-dd">
                        </el-date-picker>
                    </template>
                    <el-button
                        style="margin-left: 15px"
                        type="danger"
                        icon="el-icon-minus"
                        plain
                        circle
                        @click.native.prevent="deleteRow(index, bonusData)"
                        size="small"
                    ></el-button>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="saveOk">确 定</el-button>
                <el-button @click="outData.isshow = false">取 消</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { apiComTotal, apiComTotalPull, apiCurrentPermisson, apiSystem } from '@/request/api';
import print from 'print-js';
import html2canvas from 'html2canvas';
export default {
    name: 'comTotal',
    data() {
        return {
            kindArr: [],
            kindTotal: '',
            kindData: '',
            counterList: [],
            dtlArr: [],
            allArr: '',
            outData: { isshow: false, scope: null, index: 0, data: {} },
            bonusData: { table: [], condition: [], parameter: [] },
            tableIndex: 0,
            tableNo: 0,
            arr: [],
            arrs: [],
            pageIndex: 1,
            pageSize: 30,
            pageTotal: 0,
            img: '',
            perData: '',
            systemSet: '',
            vague: true
        };
    },
    watch: {},
    created() {
        // this.selectTable();
        this.getPull();
        this.getPermission();
        this.getSystem();
    },
    methods: {
        getPull() {
            this.$load.show();
            apiComTotalPull({}).then(res => {
                this.$load.close();
                if (res.code == 2000) {
                    this.allArr = res.data;
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },
        selectTable() {
            this.$load.show();
            apiComTotal({
                data: this.searData,
                page: this.pageIndex,
                page_size: this.pageSize
            }).then(res => {
                this.$load.close();
                if (res.code == 2000) {
                    //
                    this.dtlArr = res.data.data;
                    this.pageTotal = parseInt(res.data.count);
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },
        toImg() {
            html2canvas(this.$refs.print, {
                backgroundColor: 'white',
                useCORS: true,
                windowHeight: document.body.scrollHeight
            }).then(canvas => {
                // let url = canvas.toDataURL('image/jpeg', 1.0)
                let url = canvas.toDataURL();
                this.img = url;
                this.download();
                // printJS({
                //     printable: url,
                //     type: 'image',
                //     documentTitle: '打印图片'
                // })
            });
        },
        //下载图片
        download() {
            let imgData = this.img;
            this.downloadFile('来料统计表.png', imgData);
        },
        //下载
        downloadFile(fileName, content) {
            let aLink = document.createElement('a');
            let blob = this.base64ToBlob(content); //new Blob([content]);

            let evt = document.createEvent('HTMLEvents');
            evt.initEvent('click', true, true); //initEvent 不加后两个参数在FF下会报错  事件类型，是否冒泡，是否阻止浏览器的默认行为
            aLink.download = fileName;
            aLink.href = URL.createObjectURL(blob);

            // aLink.dispatchEvent(evt);
            //aLink.click()
            aLink.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window })); //兼容火狐
        },
        //base64转blob
        base64ToBlob(code) {
            let parts = code.split(';base64,');
            let contentType = parts[0].split(':')[1];
            let raw = window.atob(parts[1]);
            let rawLength = raw.length;

            let uInt8Array = new Uint8Array(rawLength);

            for (let i = 0; i < rawLength; ++i) {
                uInt8Array[i] = raw.charCodeAt(i);
            }
            return new Blob([uInt8Array], { type: contentType });
        },
        printContext() {
            this.$print(this.$refs.print);
        },
        // 筛选功能--------------------------------------------------
        showInput() {
            if (this.bonusData.table == null) this.bonusData.table = [];
            if (this.bonusData.condition == null) this.bonusData.condition = [];
            if (this.bonusData.parameter == null) this.bonusData.parameter = [];
            let inputValue = '';
            this.bonusData.table.push(inputValue);
            this.bonusData.condition.push(inputValue);
            this.bonusData.parameter.push(inputValue);
        },
        selectOne1(index) {
            for (var j = 0; j < this.allArr.screen_pull[0].field.length; j++) {
                if (this.allArr.screen_pull[0].field[j].name_no == this.bonusData.table[index]) this.tableNo = j;
            }
            this.arrs[index] = this.tableNo;
        },
        selectOne_vague(val) {
            if (this.bonusData.condition[0] == 'like') {
                this.vague = false;
            } else {
                this.vague = true;
            }
        },
        deleteRow(index, rows) {
            for (var i = 0; i < rows.table.length; i++) {
                if (rows.table[i] == this.bonusData.table[index]) {
                    rows.table.splice(i, 1);
                    rows.condition.splice(i, 1);
                    rows.parameter.splice(i, 1);
                }
            }
            // rows.splice(index, 1);
        },
        // 确认筛选-------------------------------------------------
        saveOk() {
            this.dtlArr = [];
            this.pageTotal = 0;
            var arrBig = [];
            for (var i = 0; i < this.bonusData.table.length && this.bonusData.condition.length && this.bonusData.parameter.length; i++) {
                arrBig[i] = {};
                arrBig[i].field = this.bonusData.table[i];
                arrBig[i].condition = this.bonusData.condition[i];
                arrBig[i].parameter = this.bonusData.parameter[i];
            }
            this.searData = arrBig;
            this.pageIndex = 1;
            this.pageSize = 30;
            //
            this.$load.show();
            apiComTotal({
                page: this.pageIndex,
                page_size: this.pageSize,
                data: arrBig
            }).then(res => {
                this.$load.close();
                if (res.code == 2000) {
                    this.outData.isshow = false;
                    this.dtlArr = res.data.data;
                    this.pageTotal = res.data.count;
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },
        // 分页导航----------------------------------------------------------------------------------------------------
        handlePageChange(val) {
            this.pageIndex = val;
            this.selectTable();
        },
        pageSizeChange(val) {
            //
            this.pageSize = val;
            this.selectTable();
        },
        //获得页面按钮的权限（添加，修改，删除）
        getPermission() {
            apiCurrentPermisson({
                id: '49'
            }).then(res => {
                if (res.code == 2000) {
                    this.perData = res.data;
                    this.username = res.data.login_staff;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        //获取系统设置信息
        getSystem() {
            apiSystem({}).then(res => {
                if (res.code == 2000) {
                    this.systemSet = res.data;
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },
        //导出摸版
        outExcel() {
            var name = this.username;
            var arr = this.searData;
            var ccc = JSON.stringify(arr);

            window.open(this.$baseURL + `inliset_total_export?data=${ccc}&login_staff=` + name, '_blank');
        }
    }
};
</script>

<style scoped>
.totaltable table {
    width: 100%;
    border-collapse: collapse;
    border: none;
}
.totaltable table td,
.totaltable table th {
    border: 1px solid #000;
    padding: 5px 0;
}
.totaltable table th {
    font-weight: bold;
    color: #000;
}
.totaltable table tr:nth-child(even) td {
    background: #e9ebed;
}
.box1 .el-select {
    width: 20%;
}
.txtleft {
    text-align: left;
    color: red;
}
.company {
    text-align: center;
    font-size: 16px;
    color: rgb(7, 16, 114);
    font-weight: bold;
    letter-spacing: 5px;
}
@media screen and (max-width: 768px) {
    .totaltable table td,
    .totaltable table th {
        font-size: 12px;
    }
    .raio {
        margin-top: 10px;
    }
    .el-pagination {
        white-space: inherit;
    }
}
@media print {
    table {
        width: 100%;
        border-collapse: collapse;
        font-size: 12px;
    }
}
</style>
